// mui
import { Typography, Grid, Link } from '@mui/material';

// client-shared
import { storage } from '@goldblack/client-storage';

function Footer() {
    return (
        <Grid container spacing={0} direction='column' justifyContent='center' alignItems='center'>
            <Typography align='center' variant='body2' noWrap color='primary.main' sx={{ m: 1 }}>
                © 2025. Loise all right reserved.
            </Typography>
        </Grid>
    );
}

export { Footer };
